module.exports = __webpack_public_path__ + "static/media/aboutus.faa093fa.svg";